import { Controller } from "stimulus";

export default class extends Controller {
  removeAddress(e) {
    e.preventDefault();

    const locationPointId = e.currentTarget.dataset.locationPointId;
    if (!locationPointId) {
      return;
    }

    const destroyField = document.querySelector(
      `input[data-location-point-id='${locationPointId}']`
    );
    if (destroyField) {
      destroyField.value = 1;
    }

    const wrapper = e.currentTarget.closest("li");
    if (wrapper) {
      wrapper.remove();
    }
  }
}
